<template>
  <div class="index">
    <van-nav-bar title="发布病例" fixed left-arrow @click-left="$router.back()" style="z-index: 9999999" />
    <div class="index-box">
      <div class="index-box-title">淋巴瘤CAR-T治疗全程管理项目</div>
      <div class="index-con">
        <div class="index-con-title" style="margin-bottom: 27px;">
          &emsp;&emsp;为了进一步推动CAR-T疗法在淋巴瘤治疗中的规范化管理，特诚邀血液肿瘤领域的各位专业医师参与本次调研。本问卷旨在了解当前国内CAR-T细胞治疗的临床应用现状，以及医师们对淋巴瘤治疗的诊疗观念。
        </div>
        <ul class="index-con-ul">
          <li class="index-con-ul-li">
            1. 本次调研所有信息仅用于学术研究，不涉及商业用途。
          </li>
          <li class="index-con-ul-li">
            2. 请根据实际情况作答，确保所填信息的完整性和准确性，请勿虚构数据或歪曲事实。
          </li>
          <li class="index-con-ul-li">
            3. 患者的个人信息将匿名处理，确保隐私安全。
          </li>
        </ul>
        <div class="index-con-title" style="margin-top: 35px;">
          本问卷预计耗时约20分钟，感谢您的耐心填写
        </div>
        <!--  -->
        <div class="index-con-form">
          <el-form :rules="rules" ref="form" :model="form" label-width="90px" class="form" hide-required-asterisk>
            <div class="form-top">
              <div>
                <el-form-item label="医生姓名：">
                  <el-input class="index-con-form-left-input" v-model="inform.real_name" placeholder="请输入医生姓名"
                    :disabled="true" />
                </el-form-item>
              </div>
              <div>
                <el-form-item label="所在医院：">
                  <el-input class="index-con-form-left-input" v-model="inform.unit" placeholder="请输入所在医院"
                    :disabled="true" />
                </el-form-item>
              </div>
              <div>
                <el-form-item label="所在科室：">
                  <el-input class="index-con-form-left-input" v-model="inform.department" placeholder="请输入所在科室"
                    :disabled="true" />
                </el-form-item>
              </div>
              <div>
                <el-form-item label="职称：">
                  <el-input class="index-con-form-left-input" v-model="inform.title" placeholder="请输入职称"
                    :disabled="true" />
                </el-form-item>
              </div>
            </div>
            <div class="form-bottom1">
              <el-form-item label="医院级别：" prop="level">
                <el-radio-group v-model="form.level">
                  <el-radio :label="1">一级</el-radio>
                  <el-radio :label="2">二级</el-radio>
                  <el-radio :label="3">三级</el-radio>
                  <el-radio :label="4" style="margin-top: 10px;">其他</el-radio>
                </el-radio-group>
              </el-form-item>
              <div class="form-bottom1-qi">
                <el-form-item prop="level_other" ref="level_other" v-if="form.level == 4">
                  <el-input style="width: 120px;" v-model="form.level_other" placeholder="请输入" />
                </el-form-item>
              </div>
            </div>
            <div class="form-bottom2">
              <el-form-item label="医院性质：" prop="nature">
                <el-radio-group v-model="form.nature">
                  <el-radio :label="1" style="margin-right: 20px;!important">综合性医院</el-radio>
                  <el-radio :label="2" style="margin-top: 10px;margin-right: 0 !important;">肿瘤专科医院</el-radio>
                  <el-radio :label="3" style="margin-top: 10px;margin-right: 100px !important;">民营/私立医院</el-radio>
                  <el-radio :label="4" style="margin-top: 10px; margin-right: 0 !important;">其他</el-radio>
                </el-radio-group>
              </el-form-item>
              <div class="form-bottom2-qi">
                <el-form-item prop="nature_other" ref="nature_other" v-if="form.nature == 4">
                  <el-input style="width: 160px;" v-model="form.nature_other" placeholder="请输入" />
                </el-form-item>
              </div>
            </div>
            <div class="form-btn">
              <el-form-item>
                <el-button
                  style="width: 120px;height: 42px;background: linear-gradient( 136deg, #9F95FF 0%, #696BFF 100%);"
                  type="primary" @click="submitForm('form')">
                  下一步
                </el-button>
              </el-form-item>
            </div>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      inform: {
        real_name: "", //医生姓名 
        unit: "", //医院
        department: "", //科室
        title: "", //职称    
      },
      form: {
        level: '',//医院水平 
        level_other: '',
        nature: '',//医院性质 
        nature_other: ''
      },
      rules: {
        level: [
          { required: true, message: '请选择医院级别', trigger: 'change' }
        ],
        level_other: [
          { required: true, message: '请输入', trigger: 'blur' }
        ],
        nature: [
          { required: true, message: '请选择医院性质', trigger: 'change' }
        ],
        nature_other: [
          { required: true, message: '请输入', trigger: 'blur' }
        ],
      }
    }
  },
  created() {
    this.geTauthMyCert()
  },
  methods: {
    //提交
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.getformApi()
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    //表单接口 
    async getformApi() {
      const { data: data } = await this.$http.post(
        "medical/doctor",
        this.form
      );
      this.$toast(data.message);
      this.$router.push({ path: '/questionnaire' })
    },
    //获取认证信息
    async geTauthMyCert() {
      const { data: data } = await this.$http.get("auth/myCert");
      if (data.data != "" && data.data != undefined && data.data != null) {
        this.inform.real_name = data.data.real_name
        this.inform.unit = data.data.unit
        this.inform.department = data.data.department
        this.inform.title = data.data.title
      }
    },
  }
}
</script> 
<style scoped>
.index {
  position: relative;
  top: 0;
  left: -15px;
  width: calc(100% + 30px);
}

.index-box {
  position: relative;
  width: 100%;
  background: url(@/assets/image/CARinlet/bgc.png) no-repeat center 0px;
  background-position: center 0px;
  background-size: cover;
  /* height: 100vh; */

  padding-bottom: 80px;

}

.index-box-title {
  color: #2B2B2B;
  font-weight: 600;
  font-size: 24px;
  padding: 28px 60px 28px 60px;
  text-align: center;
}

.index-con {
  position: relative;
  width: 345px;
  /* height: 819px; */
  height: 770px;
  margin: 0 15px;
  background: url(@/assets/image/CARinlet/con-bgc.png) no-repeat center 0px;
  background-position: center 0px;
  background-size: cover;
  padding: 30px 16px;
}

.index-con-title {
  color: #2B2B2B;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.5;

}

.index-con-ul {
  /* margin: 33px 0; */
}

.index-con-ul-li {
  color: #2B2B2B;
  font-size: 13px;
}

.index-con-ul-li:nth-child(2) {
  margin: 22px 0;
}

.index-con-form {
  position: relative;
  margin-top: 50px;
}

.index-con-form-left {
  display: flex;
  align-items: center;
}

.index-con-form-left-name {
  color: #000;
  font-size: 16px;
  width: 83px;
}

.index-con-form-left-input {
  width: 144px;
}

.index-con-form-left-input>>>.el-input__inner {
  position: relative;
  top: 0px;
  border: 0 !important;
  border-bottom: 1px solid #000000 !important;
  border-radius: 0 !important;
  background-color: rgba(0, 0, 0, 0) !important;
  padding: 0 !important;
  height: 20px;
  line-height: 20px;
}

.form-btn {
  position: absolute;
  bottom: -90px;
  left: 0;
  /* margin: 0 auto; */
  /* margin-top: 27px; */
  /* margin-top: 58px; */
  /* margin-top: 58px; */
  width: 120px;
  height: 42px;
}

/*  */
.index-con-form {
  position: relative;
}

.form-top {
  position: relative;
}

.form-top>>>.el-form-item {
  margin-bottom: 10px !important;
}

.form-bottom1 {
  margin-top: 10px;
  position: relative;
}

.form-bottom1>>>.el-radio {
  margin-right: 15px;
}

.form-bottom1-qi {
  position: absolute;
  top: 12px;
  left: 60px;
}

.form-bottom1-qi>>>.el-input__inner {
  position: relative;
  top: 0px;
  border: 0 !important;
  border-bottom: 1px solid #000000 !important;
  border-radius: 0 !important;
  background-color: rgba(0, 0, 0, 0) !important;
  padding: 0 !important;
  height: 20px;
  line-height: 20px;
}

.form-bottom2 {
  position: relative;
  margin-top: 5px;
}

.form-bottom2>>>.aaaaaa>>>.el-radio {
  margin-right: 0 !important;
}

.form-bottom2-qi {
  position: absolute;
  top: 48px;
  left: 60px;
}

.form-bottom2-qi>>>.el-input__inner {
  position: relative;
  top: 0px;
  border: 0 !important;
  border-bottom: 1px solid #000000 !important;
  border-radius: 0 !important;
  background-color: rgba(0, 0, 0, 0) !important;
  padding: 0 !important;
  height: 20px;
  line-height: 20px;
}

.index>>>.el-button--primary {
  border-color: #9F95FF !important;
}
</style>    
<style>
.el-input__inner {
  color: #000 !important;
}
</style>